import validator from 'validator';

export default class FormValidator {
  constructor() {
    this.formElement = document.querySelector('[data-form="form"]');

    this.validateAll = this.validateAll.bind(this);
    this.validateinput = this.validateInput.bind(this);
    this.getInputData = this.getInputData.bind(this);

    // this.init();
  }

  init() {
    if (!this.formElement) return;
    this.getChildren();
    this.bindEvents();
  }

  getChildren() {
    this.inputs = this.formElement.querySelectorAll('[data-form="input"]');
    this.submit = this.formElement.querySelector('[data-form="submit"]');
  }

  bindEvents() {
    this.inputs.forEach(input => input.addEventListener('blur', (e) => this.validateInput(e.currentTarget)));
    this.submit.addEventListener('click', this.validateAll);
  }

  getInputData(input) {
    const inputType = input.getAttribute('type');
    const inputValue = input.value;
    const inputName = input.getAttribute('name');
    const inputErrorMessage = input.parentNode.querySelector('[data-form="error"]');

    return { inputType, inputValue, inputName, inputErrorMessage };
  }

  showErrorMessage(text, messageEl, inputEl) {
    messageEl.innerHTML = text;
    messageEl.classList.add('is-visible');
    inputEl.classList.add('is-invalid');
  }

  showSuccessMessage(messageEl, inputEl) {
    messageEl.innerHTML = '&nbsp;';
    messageEl.classList.remove('is-visible');
    inputEl.classList.add('is-valid');
  }

  validateInput(inputEl) {
    const { inputType, inputValue, inputName, inputErrorMessage } = this.getInputData(inputEl);

    const isEmail = inputType === 'email';
    const isCheckbox = inputType === 'checkbox';
    const isEmpty = validator.isEmpty(inputValue);
    const isValidEmail = validator.isEmail(inputValue);

    inputEl.classList.remove('is-invalid', 'is-valid');

    if (isEmpty) {
      this.showErrorMessage(`${inputName}を入力してください。`, inputErrorMessage, inputEl);
    }
    else if (isEmail && !isValidEmail) {
      this.showErrorMessage('正しいメールアドレスを入力して下さい。', inputErrorMessage, inputEl);
    }
    else if (isCheckbox && !inputEl.checked) {
      this.showErrorMessage('チェックしてください。', inputErrorMessage, inputEl);
    }
    else {
      this.showSuccessMessage(inputErrorMessage, inputEl);
    }
  }

  validateAll() {
    this.inputs.forEach(input => this.validateInput(input));
  }
}
